import { render } from "./product4.vue?vue&type=template&id=2e689506&scoped=true"
import script from "./product4.vue?vue&type=script&lang=js"
export * from "./product4.vue?vue&type=script&lang=js"

import "./product4.vue?vue&type=style&index=0&id=2e689506&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e689506"]])

export default __exports__